import React, { Component } from "react";
import { Row } from "antd";
import { withRouter, RouteComponentProps } from "react-router";

/**
 * state
 *
 * @interface StateOwn
 */
interface StateOwn {
  path: string;
}

/**
 * 系统首页
 *
 * @class VhHome
 * @extends {Component}
 */
class MsApp extends Component<RouteComponentProps, StateOwn> {
  /**
   * Creates an instance of VhApp.
   * @param {RouteComponentProps} props
   * @memberof VhApp
   */
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      path: ""
    };
  }

  /**
   * 组件初次加载后
   *
   * @memberof VhHome
   */
  public componentDidMount() {
    if (this.props.location.state) {
      this.setState({
        path: (this.props.location.state as any).path
      });
    } else {
      this.props.history.push("/no-service/404");
    }
  }

  /**
   * 渲染组件
   *
   * @returns
   * @memberof VhHome
   */
  public render() {
    return (
      <Row style={ {height: "100%"} }>
        <iframe title="app" style={{width: "100%", height: "100%"}} src={this.state.path} />
      </Row>
    );
  }
}

export default withRouter(MsApp);
